import { render, staticRenderFns } from "./editClassificationDialog.vue?vue&type=template&id=556db2ae&scoped=true&"
import script from "./editClassificationDialog.vue?vue&type=script&lang=js&"
export * from "./editClassificationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556db2ae",
  null
  
)

export default component.exports